import React from "react";
import logo from "../../../assets/svg/auth/logo.svg";
import useCustomScrollbar from "../../../styles/useCustomScrollbar";
import "../../../styles/customScrollbar.css";

interface AuthLayoutProps {
  children: React.ReactNode;
  /** A wider column, for a screen whose rows do not read well at form width. */
  wide?: boolean;
  /**
   * Off for a screen that states the same terms itself - the consent screen
   * asks for them as explicit ticks, so the footer would say it twice and in
   * weaker words than the thing the user is actually agreeing to.
   */
  showFooter?: boolean;
}

/**
 * Shared shell for the auth screens: logo pinned top-left, the form column
 * centred in the viewport, legal copy pinned to the bottom.
 *
 * The screen scrolls inside itself rather than letting the document scroll,
 * which is what puts the app's own overlay scrollbar on it instead of the
 * platform's - the same one the signed-in shell uses. `overflow: auto` comes
 * with the class, so it still only appears when a screen is actually too tall.
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  wide = false,
  showFooter = true,
}) => {
  // Reveals the thumb on hover, scroll and drag. Safe to call per auth screen:
  // it attaches once per element and cleans up on unmount.
  useCustomScrollbar();

  return (
    <div className="h-screen bg-white custom-scrollbar-overlay">
      {/* `min-h-full`, not `min-h-screen`: the height to fill is the scroll
          container's, or a screen taller than the viewport would be measured
          against the viewport twice and leave a dead band below the footer. */}
      <div className="min-h-full flex flex-col px-5 py-6 sm:px-12 sm:py-10 3xl:px-16 3xl:py-14">
        <header>
          <img src={logo} alt="Naurist" className="h-6 sm:h-6 3xl:h-7 w-auto" />
        </header>

        <main className="flex-1 flex items-center justify-center py-10">
          <div
            className={`w-full ${
              wide
                ? "max-w-[560px] 3xl:max-w-[620px]"
                : "max-w-[460px] 3xl:max-w-[520px]"
            }`}
          >
            {children}
          </div>
        </main>

        {/* {showFooter && (
          <footer className="mx-auto max-w-[480px] 3xl:max-w-[560px] text-center text-[12px] 3xl:text-[14px] leading-6 text-[#5A6672]">
            By clicking &ldquo;Log in&rdquo; or &ldquo;Continue with
            Google&rdquo; you agree to our{" "}
            <a href="/terms" className="text-[#00C2CB] hover:underline">
              Terms of Use
            </a>{" "}
            and acknowledge that you have read and understand our{" "}
            <a href="/privacy" className="text-[#00C2CB] hover:underline">
              Privacy Policy
            </a>
            .
          </footer>
        )} */}
      </div>
    </div>
  );
};

export default AuthLayout;
